// extracted by mini-css-extract-plugin
export default {"image":"kX-z","loaded":"lX-z"};